import { Card, CardContent, Skeleton, Typography } from '@client/toolkit';
import classNames from 'classnames';

interface MetricCardProps {
  title: string;
  titleClassName?: string;
  titleAdornment?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

export const MetricCard = ({ title, titleClassName, titleAdornment, className, children, isLoading }: MetricCardProps) => (
  <Card className={classNames(`w-full bg-surface-elevated/40 !overflow-clip`, className)} data-testid="metric-card">
    <CardContent className="flex flex-col justify-center gap-2 py-4 px-2">
      <div className="flex items-center gap-1.5">
        <Typography className={titleClassName}>{title}</Typography>
        {titleAdornment}
      </div>
      {isLoading ? <Skeleton className="w-full h-[32px]" /> : children}
    </CardContent>
  </Card>
);
